import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './data-card-row.module.scss';
import ChartArea from './chart-area';
import Select from 'react-select';
import * as selectors from '../../reducers';
import { connect } from 'react-redux';
import { getCategoryUnit, camelize } from '../../helpers/formatters';
import definitionMapper from '../../helpers/definition-mapper';
import throttle from 'lodash/throttle';
import './data-card-row.css';

class DataCardRow extends Component {
  constructor(props) {
    super();
    this.state = {
      selectedSubCategory: props.data.subCategories
        ? props.data.subCategories[0]
        : null,
      visible: false,
    };
    this.handleSubCategoryChange = this.handleSubCategoryChange.bind(this);
    this.handleScroll = throttle(this.handleScroll.bind(this), 100);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidMount() {
    this.handleScroll();
  }

  componentWillUnmount() {
    this.removeListener();
  }

  removeListener() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    // Commented version is slightly prettier on scroll, but means card is blank on opening on Chrome
    // if (this.props.revealed && !this.state.visible && this.isInView()) {
    if (!this.state.visible && this.isInView()) {
      this.setState({
        visible: true,
      });
      this.removeListener();
    }
  }

  isInView() {
    const el = this.containerElement;
    const rect = el.getBoundingClientRect();
    const elemTop = rect.top;
    const elemBottom = rect.bottom;
    return elemTop < window.innerHeight * 0.85 && elemBottom >= 0;
  }

  handleSubCategoryChange(selectedSubCategory) {
    this.setState({ selectedSubCategory });
  }

  renderSelect(row) {
    const { selectedSubCategory } = this.state;
    const { color, isCardExpanded } = this.props;
    if (!row.subCategories) return null;
    const options = row.subCategories.filter((x) => x.value !== '_trend');
    if (options.length < 2) return null;
    return (
      <div
        className={styles.selectWrapper}
        onClick={(e) => e.stopPropagation()}
      >
        <Select
          tabIndex={isCardExpanded ? '0' : '-1'}
          className={`subCategoryDropdown ${color}`}
          name="subCategoryDropdown"
          value={selectedSubCategory}
          onChange={this.handleSubCategoryChange}
          style={{ zIndex: 1000 }}
          options={options}
          clearable={false}
        />
      </div>
    );
  }

  renderChartsArea() {
    const { data, color, cardTitle } = this.props;
    const { selectedSubCategory, visible } = this.state;

    const title = data.title === 'total' ? cardTitle : data.title;
    const chartData = selectedSubCategory
      ? data.data[selectedSubCategory.value]
      : data.data;

    var unit = getCategoryUnit(data.key);

    // Different units for the Other information chart
    switch (title) {
      case 'Generation capacity':
        unit = 'percentage';
        break;
      case 'Power stations':
        unit = 'mw';
        break;
      default:
        break;
    }

    return (
      <div className={styles.dataCardRowRight}>
        <ChartArea
          data={typeof chartData !== 'undefined' ? chartData : null}
          title={title}
          color={color}
          unit={unit}
          visible={visible}
          trend={data.data._trend && data.data._trend[0].value}
        />
      </div>
    );
  }

  render() {
    const { data, cardTitle, comparedEntity } = this.props;
    const { visible } = this.state;
    if (data.title === 'total') {
      data.key = camelize(cardTitle);
    }

    return (
      <div
        className={styles.dataCardRow}
        ref={(r) => (this.containerElement = r)}
        data-visible={visible}
        data-empty={
          Object.keys(data.data).length === 0 ||
          (comparedEntity !== null && data.key === 'facilitiesPerEntity')
        }
      >
        {Object.keys(data.data).length > 0 ? (
          <div className={styles.dataCardRowLeft}>
            {data.title !== 'total' ? (
              <div className={styles.dataCardRowTitle}>{data.title}</div>
            ) : null}
            <div>
              {definitionMapper(
                this.props.activeEntity.entityType,
                data.key,
                this.props.activeEntity.name
              )}
            </div>
            {this.renderSelect(data)}
          </div>
        ) : null}

        {Object.keys(data.data).length > 0 ? this.renderChartsArea() : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  comparedCouncil: selectors.getComparedCouncil(state),
  comparedEntity: selectors.getComparedEntity(state),
  activeEntity: selectors.getActiveEntity(state),
});

DataCardRow.propTypes = {
  activeEntity: PropTypes.object,
  comparedCouncil: PropTypes.object,
  comparedEntity: PropTypes.object,
  data: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  cardTitle: PropTypes.string.isRequired,
  isCardExpanded: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, null)(DataCardRow);



// WEBPACK FOOTER //
// ./src/components/data-card-row/data-card-row.js